export const cards = [
  {
    title: 'Tokenizer',
    image: '/v2/products-card-img-1.png',
    text_1:
      'Make real estate tokenization simple. Our platform gives developers everything they need, secure, compliant tools and the right tech to bring properties on-chain, hassle-free.',
    features: [
      'Expert legal opinions, complete coverage, and customized documentation',
      'Fully compliant, secure, and protected with 24/7 support',
      'Ready-to-use smart contracts, security audited, and full control for you',
    ],
  },
  {
    title: 'RWA Estate',
    image: '/v2/products-card-img-2.png',
    text_1:
      'RWA-estate.com is the world’s first global aggregator of tokenized real estate.',
    text_2:
      'Explore properties from around the globe with real-time data, detailed descriptions, asset characteristics, and more powered by a growing network of 10 international partners.',
    features: [
      'Tokenized property aggregator',
      'Real estate in different regions',
      'Real-time token data & property details',
    ],
  },
  {
    title: 'Real Estate Tokenization Consortium',
    image: '/v2/products-card-img-3.png',
    text_1:
      'The Real Estate Tokenization Consortium (RETC) is a global alliance reshaping how real estate is owned and traded through blockchain.',
    text_2:
      'We bring together developers, legal experts, institutions, and innovators to standardize and advance secure, transparent, and compliant real estate tokenization worldwide.',
  },
];